/**
 * Created by karora on 11/03/17.
 */

export class Hub {

  get version(): string {
    if (this.swversion) { return this.swversion; }
    return `${this.major}.${this.minor}.${this.patch}`;
  }
  hubid: number;
  serial: number;
  name: string;
  address: string;
  city: string;
  machineid: string;
  created: string;
  age: number;
  avg_wake_secs: number;
  bias: number;
  boiler: boolean;
  current: number;
  heating: number;
  holiday: boolean;
  hub_health: string;
  humidity: number;
  gap: number;
  interval: number;
  last_seen: string;
  last_success: number;
  voltage: number;
  raw_temp: number;
  rssi: number;
  setpoint: number;
  temperature: number;
  touched: boolean;
  uptime: number;
  major: number;
  minor: number;
  patch: number;
  swversion: string;
  wifi_version: number;
  wires: number;
  customer_type_id: number;
  customer_type_description: string;
  wake_secs: number;
  installed: string;

  public static HubIDToSerial(hubID: number): number {
    let serial = hubID + 10000;
    serial = (serial * 100) + 98 - (serial % 97);
    return serial;
  }

  public static ValidSerial(serial: number): boolean {
    let hubid = Math.trunc(serial / 100) - 10000;
    return serial === this.HubIDToSerial(hubid);
  }

  public static SerialToHubID(serial: number): number {
    let hubid = Math.trunc(serial / 100) - 10000;
    let testSerial = this.HubIDToSerial(hubid);
    if ( testSerial !== serial) {
      //console.log(`Invalid serial number for hub ${hubid} should be ${testSerial}`);
      hubid = 0;
    }
    return hubid;
  }
}
